// extracted by mini-css-extract-plugin
export default {"backIcon":"AdminMobileCateRegister_backIcon__w-VtA","regiBtn":"AdminMobileCateRegister_regiBtn__ST1oG"};